import React from 'react'
import ImageSlash from '../../../../../assets/svg/image-slash.svg'
import { Parser } from '../../common'

const ImageIllustration = ({ block, position }) => {
    const [error, setError] = React.useState(false)

    const handleError = (e) => {
        setError(true)
        e.target.src = ImageSlash
    }

    return (
        <div className={`${error && 'baseocom-image-content-error'}  baseocom-image-content`}>
            <img
                src={block?.attributes?.LienPublication}
                alt="Image Illustration"
                onError={handleError}
            />
            {block?.childrens && position === 'horizontal' ? (
                <Parser content_block={block?.childrens} />
            ) : null}
        </div>
    )
}

export default ImageIllustration
